import { C2B_SELLER_FINANCE_PATH } from "../constants/api-constants";
import { convertJsonToQueryParams } from "../utils/helpers/convert-json-to-query-params";
import middlewareConfig from "./middleware-config";
import { MIDDLEWARE_ENUMS } from "./middleware-constants";

const {
    CREATE_SELLER_INTENT,
    CAPTURE_SELLER_INTENT,
    SUBMIT_SELLER_FORM,
    UPLOAD_DOCUMENT,
    VERIFY_OTP,
    NEW_CREATE_SELLER_INTENT,
    INTENT_INFO,
    CHECK_LEAD_PHONE_MATCH,
    FETCH_LEAD_PHONE
} = C2B_SELLER_FINANCE_PATH;

const c2bSellerFinanceApi = (api) => {
    const createSellerIntent = (token, source) => {
        const body = source ? { source } : {};
        return api.post(`${CREATE_SELLER_INTENT}`, body, {
            headers: {
                Authorization: `BEARER ${token}`
            }
        });
    };

    const captureSellerIntent = (authToken, source) => {
        const body = { source, authToken };
        return api.post(`${CAPTURE_SELLER_INTENT}`, body, {
        });
    };

    const submitSellerForm = (formData, token) => {
        return api.post(`${SUBMIT_SELLER_FORM}`, formData, {
            headers: {
                Authorization: `BEARER ${token}`
            }
        });
    };

    const uploadDocuments = (body) => {
        const token = body.get("token");
        return api.post(`${UPLOAD_DOCUMENT}`, body, {
            headers: {
                Authorization: `BEARER ${token}`
            }
        });
    };

    const sfSendOtp = (body) => {
        return api.post(`${CREATE_SELLER_INTENT}/token`, body);
    };

    const sfVerifyOtp = (body) => {
        return api.post(`${VERIFY_OTP}`, body);
    };

    const newCreateSellerIntent = (body) => {
        return api.post(`${NEW_CREATE_SELLER_INTENT}`, body);
    };

    const getIntentInfo = (params) => {
        const apiParams = convertJsonToQueryParams(params || {});
        return api.get(`${INTENT_INFO}?${apiParams.toString()}`, params);
    };

    const checkLeadPhoneMatch = ({ token, phone }) => {
        return api.get(`${CHECK_LEAD_PHONE_MATCH}/${token}/phone-changed/${phone}`);
    };

    const fetchLeadDetails = (token) => {
        return api.get(`${FETCH_LEAD_PHONE}/${token}`);
    };

    return {
        createSellerIntent,
        captureSellerIntent,
        submitSellerForm,
        uploadDocuments,
        sfSendOtp,
        sfVerifyOtp,
        newCreateSellerIntent,
        getIntentInfo,
        checkLeadPhoneMatch,
        fetchLeadDetails
    };
};

export const C2BSellerFinanceService = c2bSellerFinanceApi(
    middlewareConfig(MIDDLEWARE_ENUMS.C2B_SELLER_FINANCE)
);
